import React, { useEffect, useMemo, useRef, useState } from 'react';
import { trackProductPageModifierClick } from '../../analytics/pulseClickIds';
import { useParams, useLocation, useNavigate, Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import * as CONSTANT from '../../constants';
import styleClasses from './order.module.scss';
import useItem from '../../react-query-hooks/useItem';
import Spinner from '../../components/Spinner/Spinner';
import { useAuthState } from '../../context/UserAuthentication/context';
import {
  availableForSelectedOrderType,
  availableModifiers,
  createPayloadToSync,
  processEditItemModifiers,
  sortBasedOnPriceByModifierGroups,
  unavailableModifiers,
  unavailableModifiersList,
  verifyStatus,
} from '../../helpers/customizedItem/customizedItem.helper';
import { IRouteParams } from '../../models/order';
import { useSelector, useStore } from 'react-redux';

import {
  addItem,
  editItem,
  resetContext,
  sizeSelection,
  updateModifiers,
  updatePriceForAllItem,
  updatePriceForItem,
  updateTry2ComboSelectedModifiers,
} from '../../redux/slices/itemCustomizationSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store/store';
import _debounce from 'lodash/debounce';
import { startLocationFlow } from '../../redux/slices/itemSlice';
import { itemBuckets } from '../../priceCalculation/buckets';
import { calculatePriceForItem } from '../../priceCalculation/calculatePrice';
import ItemOrder from '../../components/OrderAnItem/ItemOrder';
import UserSelections from '../../components/UserSelections/UserSelections';
import useAddToOrder from '../../hooks/useAddToOrder';
import Customization from './OrderCustomization/Customization';
import { APPLY, ROUTE_MENU } from '../../constants';
import useGetCartItem from '../../react-query-hooks/Cart/useGetCartItem';
import {
  getVisitorId,
  isItCreateYourOwnItem,
  showMakeItTryToCombo,
} from '../../helpers/helperMethods';
import { IGetItemFromCartPayload } from '../../models/order.model';
import { modifiersAgainstAnItem } from '../../priceCalculation/helper';
import { toast } from 'react-toastify';
import { useStoreLocation } from '../../context/StoreLocation';
import { API_ERROR_MESSAGE } from '../../models/error.model';
import { Toast_Func } from '../../helpers/toast.helper';
import AddedModal from './AddedModal/AddedModal';
import ItemDetailMenuCategory from './ItemDetailMenuCategory/ItemDetailMenuCategory';
import _clonedeep from 'lodash.clonedeep';
import { cartItem } from '../../models/cart.model';
import ItemScript from '../../components/scripts/itemScript';
import SelectMenuItemScript from '../../components/scripts/selectMenuItemScript';
import { trackItemVisit } from '../../helpers/recentlyVisitedItems';
import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';
import { setShowCart } from '../../redux/slices/cartSlice';
import useTrackBarVisibility from '../../hooks/useTrackBarVisibility';
import { useIsDesignV2 } from '../../hooks/useIsDesignV2';
import { useQueryClient } from 'react-query';
import {
  fetchNestedMenuItemForTray,
  mergeSandwichTrayMenuFields,
} from '../../helpers/nestedTrayMenuItem.helper';
import {
  areStandaloneSubItemModifierSelectionsComplete,
  isSandwichTrayItem,
  resolveParentTrayItemForChips,
  trimSandwichTrayChipsSelections,
} from '../../helpers/sandwichTrayChips.helper';
import {
  byDefaultSeletedItems,
  calculateAndUpdateTotalAdditionalPrice,
  seedItemsAsModifierFromCart,
} from '../../priceCalculation/itemsAsModifierPrice';
import { mapSizesKey, IItemAsModifiers } from '../../models/item.model';
const Order: React.FunctionComponent = () => {
  let { id: item_id } = useParams<IRouteParams>();
  const history = useNavigate();
  const queryClient = useQueryClient()
  const [itemOrderResetKey, setItemOrderResetKey] = useState(0);
  
  if (item_id.includes('?')) {
    item_id = item_id.split('?')[0];
  }
  // const scrollToTop = useRef<HTMLDivElement>()
  const [showModal, setshowModal] = useState<boolean>(false);
  const [modalShow, setModalShow] = useState<boolean>(false);
  const { addToOrder, loading } = useAddToOrder();
  const [firstTimeModal, setFirstTimeModal] = useState(false);
  const [forceRender, setForceRender] = useState(false);
  const [addToOrderStickyButton, setAddToOrderStickyButton] = useState(false);
  const [customizedItem, setCustomizedItem] = useState<cartItem>(null);
  // let { search, state } = useLocation();
  let location = useLocation();
  const dispatch = useAppDispatch();
  const store:any = useStore();
  const order = useSelector((state: any) => state.itemCustomization);
  const recentlyDeletedId = useSelector(
    (state: any) => state.cart.recentlyDeletedId
  );
  const orderType = useSelector((state: any) => state.cart.orderType);
  const cart = useAppSelector((state) => state.cart);

  /* When cusotmers edit an item order container receives state to show customization section */
  let isEdit =
    (location.state as { showCustomization?: boolean })?.showCustomization ?? false;
  const reward_size = (location.state as { reward_size?: string })?.reward_size;
  const isItemRedeemed = (location.state as { isItemRedeemed?: boolean })
    ?.isItemRedeemed;
  const { authInfo } = useAuthState();
  const closeAddedModal = () => {
    resetItem();
    setshowModal(false);
  };

  const isOrderTypeSelected = cart?.isOrderTypeSelected;
  const savedOrderType = cart?.orderType;
  const isThisMobile = useCheckMobileScreen();

  const query = new URLSearchParams(location.search);
  const { locationInfo } = useStoreLocation();
  const location_id = locationInfo.selectedStore?.id;

  const category_id = query.get('category_id');
  let dbId = query.get('id');
  const [showCustomizedOptions, setShowCustomizedOptions] = useState(false);
  const [redeemSize, setRedeemSize] = useState(null);

  const {
    data,
    isFetching,
    refetch: refetchItem,
    isError: isUseItemError,
    error: useItemError,
  } = useItem({
    location_id: location_id,
    category_id: category_id,
    item_id: item_id,
    ...(authInfo.userId
      ? { customer_id: Number(authInfo.userId) }
      : { visitor_id: getVisitorId() }),
  });
  const [sandwichTrayMerge, setSandwichTrayMerge] = useState<any>(null);
  const [itemsAsModifier, setItemsAsModifier] = useState<IItemAsModifiers[]>(
    []
  );
  const lastTraySeedKeyRef = useRef<string | null>(null);
  const hasSeededEditSelectionsRef = useRef(false);
  /** Live menu item: API payload, or merged detail after nested fetch for sandwich trays. */
  const item = useMemo(() => {
    if (!data) {
      return null as any;
    }
    return sandwichTrayMerge ?? data;
  }, [data, sandwichTrayMerge]);
  const subItemsMeta =
    item?.sub_items_required_modifier_groups
      ?.map(
        (g: { id: number; items_as_modifier?: unknown[] }) =>
          `${g.id}:${(g.items_as_modifier ?? []).length}`
      )
      .join('|') ?? '';
  const {
    requiredModifiersAtItemDetailSectionToHandleScroll,
    requiredCYOIModifiersToHandleScroll,
  } = useScrollToMissingRequiredArea(item);

  useEffect(() => {
    setSandwichTrayMerge(null);
    lastTraySeedKeyRef.current = null;
    hasSeededEditSelectionsRef.current = false;
    setItemsAsModifier([]);
  }, [item_id, data?.id]);

  useEffect(() => {
    const base = data;
    if (!base || !location_id || !category_id) return;
    if (!isSandwichTrayItem(base)) return;
    if ((base.sub_items_required_modifier_groups?.length ?? 0) > 0) return;

    let cancelled = false;
    (async () => {
      const full = await fetchNestedMenuItemForTray({
        location_id,
        category_id: String(category_id),
        item_id: String(base.id),
        user: {
          id: authInfo.userId ? Number(authInfo.userId) : undefined,
          type: authInfo.type,
        },
      });
      if (cancelled || !full) return;
      setSandwichTrayMerge(mergeSandwichTrayMenuFields(base, full));
    })();
    return () => {
      cancelled = true;
    };
  }, [
    data?.id,
    data?.is_sandwich_tray,
    data?.sub_items_required_modifier_groups?.length,
    location_id,
    category_id,
    authInfo?.userId,
    authInfo?.type,
  ]);

  useEffect(() => {
    if (isUseItemError) {
      const apiError = useItemError as API_ERROR_MESSAGE;
      const message =  apiError?.response?.data?.message || 'Something went wrong. Please try again';
      Toast_Func({ status: false, message })
      history(CONSTANT.ROUTE_MENU);
    }  
  }, [isUseItemError, useItemError]);

  const setSizeForItemsAsModifier = (activeItem: any) => {
    const currentItem = _clonedeep(activeItem ?? item);
    if (currentItem?.is_soup_tray) {
      return CONSTANT.HALF_SIZE.id;
    }
    if (currentItem?.half_brink_item_id) {
      return CONSTANT.HALF_SIZE.id;
    }
    return CONSTANT.FULL_SIZE.id;
  };

  const modifierCodeForItemsAsModifier = (itemRow: any) => {
    if (itemRow?.actualQuantity > itemRow?.quantity) {
      return CONSTANT.NO;
    }
    return CONSTANT.ADD;
  };

  const addItemsAsModifierInPayload = (structuredOrder: any) => {
    if (!structuredOrder?.item_id) {
      return structuredOrder;
    }
    structuredOrder.modifiers = structuredOrder.modifiers ?? [];
    const newItemsAsModifiers = _clonedeep(
      itemsAsModifier.filter((currentItemAsModifier: any) => {
        if (currentItemAsModifier.parentItem?.cart_id) {
          return (
            currentItemAsModifier.parentItem.item_id === structuredOrder.item_id
          );
        }
        return currentItemAsModifier.parentItem?.id === structuredOrder.item_id;
      })
    );

    const resultedArray: any[] = [];
    const selectedItemsRecord = new Set();

    for (let index = 0; index < newItemsAsModifiers.length; index++) {
      const val = newItemsAsModifiers[index].selectedItems.reduce(function (
        arr: any[],
        selectedItem: any
      ) {
        let found = false;
        selectedItem.parentItem = newItemsAsModifiers[index]?.parentItem;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id === selectedItem.id) {
            found = true;
            arr[i].quantity += selectedItem.quantity;
            arr[i].additionalPrice += selectedItem.additionalPrice;
          }
        }

        if (!found) {
          arr.push(selectedItem);
          selectedItemsRecord.add(selectedItem.id);
        }

        return arr;
      }, []);
      resultedArray.push(val);

      (newItemsAsModifiers[index].byDefaultSelectedItems ?? []).map(
        (defaultSelectedItem: any): void => {
          if (!selectedItemsRecord.has(defaultSelectedItem.id)) {
            const payload = {
              modifier_id: defaultSelectedItem.id,
              modifier_name: defaultSelectedItem.name,
              modifier_group_id: defaultSelectedItem.modifier_group_id,
              display_price: defaultSelectedItem.additionalPrice,
              isCore: defaultSelectedItem.isByDefault ?? false,
              quantity: 0,
              code: CONSTANT.NO,
              modifier_type: 'sub_item_required_modifiers',
              size: setSizeForItemsAsModifier(newItemsAsModifiers[index]?.parentItem),
              is_item: true,
            };
            resultedArray.push(payload);
            selectedItemsRecord.add(defaultSelectedItem.id);
          }
        }
      );
    }

    resultedArray
      .flat()
      .map((currentItem: any): void => {
        if (currentItem.quantity === 0) {
          structuredOrder.modifiers.push(currentItem);
        } else {
          const payload = {
            modifier_id: currentItem.id,
            modifier_name: currentItem.name,
            modifier_group_id: currentItem.modifier_group_id,
            display_price: currentItem.additionalPrice,
            isCore: currentItem.isByDefault ?? false,
            quantity: currentItem.quantity,
            code: modifierCodeForItemsAsModifier(currentItem),
            modifier_type: 'sub_item_required_modifiers',
            size: setSizeForItemsAsModifier(currentItem.parentItem),
            is_item: true,
          };
          selectedItemsRecord.add(currentItem.id);
          structuredOrder.modifiers.push(payload);
        }
      });
    return structuredOrder;
  };

  const handleAddToOrder = async (structuredOrder, isCombo = false) => {
    const payloadWithItemsAsModifier = addItemsAsModifierInPayload(
      _clonedeep(structuredOrder)
    );
    const response = await addToOrder(
      payloadWithItemsAsModifier,
      isCombo,
      payloadWithItemsAsModifier?.quantity
    );
    if (response) {
      // Get the current state from the history
      const currentState: any = location.state;

      // Remove the specific entry you want to remove
      const updatedState = { ...currentState, reward_size: undefined };

      // Use history.replace to update the current history entry with the new state
      history(location.pathname + location.search, {
        replace: true,
        state: updatedState,
      });
      setCustomizedItem(payloadWithItemsAsModifier);
      setshowModal(true);
    }
    return response;
  };

  const payload: IGetItemFromCartPayload = {
    id: dbId,
    location_id: location_id,
  };
  if (authInfo.userId) payload.customer_id = authInfo.userId;
  else payload.visitor_id = getVisitorId();

  const {
    data: editCartItem,
    refetch,
    isFetching: editItemFetching,
    isError,
  } = useGetCartItem(payload);

  const showCustomizationOnEdit = editCartItem?.is_customizable ?? false;

  useEffect(() => {
    if (!item || !order?.size) return;
    const groups = item.sub_items_required_modifier_groups;
    const groupCount = groups?.length ?? 0;
    if (!groupCount) return;

    // While editing, wait for the saved cart item before seeding so we restore
    // the user's previous selections instead of locking in menu defaults.
    if (isEdit && dbId && !editCartItem) return;

    const editingThisItem = Boolean(
      isEdit && dbId && editCartItem && editCartItem.item_id === item.id
    );
    // Restore saved selections only for the first seed of an edit session.
    // After that (e.g. when the size changes) fall back to by-default selection.
    const shouldRestoreFromCart =
      editingThisItem && !hasSeededEditSelectionsRef.current;

    const key = `${item.id}-${order.size}-${groupCount}`;
    if (lastTraySeedKeyRef.current === key) return;
    lastTraySeedKeyRef.current = key;

    if (itemsAsModifier.length > 0) {
      calculateAndUpdateTotalAdditionalPrice(itemsAsModifier, '-', dispatch);
    }

    let currentlySelected: IItemAsModifiers[] = [];
    if (shouldRestoreFromCart) {
      currentlySelected = seedItemsAsModifierFromCart({
        groups,
        cartSubItemModifiers: editCartItem.sub_item_required_modifiers ?? [],
        order,
        parentItem: item,
      });
      hasSeededEditSelectionsRef.current = true;
    } else {
      groups.forEach((group: any) => {
        byDefaultSeletedItems({
          currentItemGroup: group,
          items: groups,
          mapSizesKey,
          order,
          currentlySelectedItemsAsModifier: currentlySelected,
          parentItem: item,
        });
      });
    }
    setItemsAsModifier(currentlySelected);
    if (currentlySelected.length > 0) {
      calculateAndUpdateTotalAdditionalPrice(currentlySelected, '+', dispatch);
    }
  }, [
    item?.id,
    order?.size,
    subItemsMeta,
    itemsAsModifier,
    dispatch,
    item,
    isEdit,
    dbId,
    editCartItem,
  ]);

  const unavailableModifiersListData = unavailableModifiersList(item);
  const autoScrollDivRef = useRef<HTMLDivElement>(null);
  const isNavigatingToCombo = useRef<boolean>(false);

  const openCartAfterAddingAndItem = () => {
    dispatch(setShowCart(true));
    sessionStorage.setItem('recently_item_added_to_cart', '0');
  };

  useEffect(() => {
    return () => {
      setModalShow(false);
      setFirstTimeModal(false);
    };
  }, [dbId]);

  useEffect(() => {
    if (!location_id) {
      const itemPath = {
        pathname: `${CONSTANT.ROUTE_ORDER}/${item_id}`,
        search: `category_id=${category_id}`,
      };
      dispatch(startLocationFlow(itemPath));
      history('/menu');
      window.dispatchEvent(new CustomEvent("openLocationSelectionModal"));
    }
  }, [location_id]);

  useEffect(() => {
    if (!isEdit || !dbId) return;
    if (recentlyDeletedId === Number(dbId) || isError) {
      toast.error('This Item does not exist!');
      history('/menu');
    }
  }, [recentlyDeletedId, isError]);

  useEffect(() => {
    if (isEdit && dbId) {
      dispatch(resetContext());
      itemBuckets.resetBuckets();
      itemBuckets.createComboBucket({
        keys: [
          CONSTANT.REQUIRED_MODIFIERS,
          CONSTANT.CORE_MODIFIERS,
          CONSTANT.ADD_ONS,
          CONSTANT.COMPLIMENTARY_MODIFIER,
        ],
        items: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
      });
      if (item_id && location_id) {
        refetchItem();
      }
      refetch();
    }
  }, [isEdit, dbId]);

  useEffect(() => {
    unavailableModifiersListData &&
      !showCustomizedOptions &&
      setShowCustomizedOptions(true);
  }, [unavailableModifiersListData]);

  useEffect(() => {
    /* Handle View Cart Click To Open Cart On Page Reload @param = recently_item_added_to_cart*/
    const isOpenCart = sessionStorage.getItem('recently_item_added_to_cart');
    parseInt(isOpenCart) && openCartAfterAddingAndItem();

    itemBuckets.createComboBucket({
      keys: [
        CONSTANT.REQUIRED_MODIFIERS,
        CONSTANT.CORE_MODIFIERS,
        CONSTANT.ADD_ONS,
        CONSTANT.COMPLIMENTARY_MODIFIER,
      ],
      items: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
    });
    if (item_id && location_id) {
      refetchItem();
    }
    // refetch()
    return () => {
      if (
        !location.pathname.includes(CONSTANT.TRY_2_COMBO_CAPITALIZE) &&
        !isNavigatingToCombo.current
      ) {
        itemBuckets.resetBuckets();
        dispatch(resetContext());
      }
    };
  }, []);

  useEffect(() => {
    const currentState: any = location.state;
    if (item_id && location_id && currentState?.is_recommended) {
      itemBuckets.resetBuckets();
      dispatch(resetContext());
      itemBuckets.createComboBucket({
        keys: [
          CONSTANT.REQUIRED_MODIFIERS,
          CONSTANT.CORE_MODIFIERS,
          CONSTANT.ADD_ONS,
          CONSTANT.COMPLIMENTARY_MODIFIER,
        ],
        items: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
      });
      refetchItem();
    }
  }, [item_id]);

  // Hook to initialize state with default data
  useEffect(() => {
    if (item) {
      if (order.modifiers.length === 0) {
        dispatch(addItem(item));
      }

      // Track the item visit for recently visited items feature
      // Only track if not from recent banner to avoid circular tracking
      const currentState: any = location.state;
      if (!currentState?.from_recent_banner) {
        try {
          trackItemVisit({
            id: Number(item.id), // Ensure number
            name: item.name,
            category_name: item.category_name,
            category_id: item.category_id,
            itemType: 'single'
          });
        } catch (error) {
          console.warn('Error tracking item visit:', error);
        }
      }
    }
  }, [item, isFetching]);

  useEffect(() => {
    if (editCartItem && isEdit && !editItemFetching) {
      dispatch(editItem(editCartItem));
    }
  }, [editCartItem, editItemFetching]);

  useEffect(() => {
    itemBuckets.addCoreModifierMemoryChip(
      CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
      item?.bucket,
      item?.items_modifier_groups
    );
    item && handleSyncIngredients(item);
  }, [item, isEdit, editCartItem]);

  // Hook to auto scroll down at specific option
  useEffect(() => {
    !firstTimeModal && scrollOnSize();
  }, [showCustomizedOptions]);

  const resetItem = () => {
    const params = new URLSearchParams(location.search);
    if(dbId) {
      params.delete('id');
      dbId = null;
      isEdit = false;
            // clear editCartItem cache so hook returns default state
      queryClient.setQueryData('get-cart-item', null);
      queryClient.resetQueries('get-cart-item');
      queryClient.removeQueries('get-cart-item');
    }
    const cleanSearch = params.toString() ? `?${params.toString()}` : '';
    const target = { pathname: location.pathname, search: cleanSearch };
    history(target, { replace: true });
    dispatch(resetContext());
    setItemsAsModifier([]);
    setSandwichTrayMerge(null);
    lastTraySeedKeyRef.current = null;
    hasSeededEditSelectionsRef.current = false;
    const updatedOrder = store.getState().itemCustomization;

    queryClient.resetQueries("get-cart-item");
    itemBuckets.resetBuckets();

    itemBuckets.createComboBucket({
      keys: [
        CONSTANT.REQUIRED_MODIFIERS,
        CONSTANT.CORE_MODIFIERS,
        CONSTANT.ADD_ONS,
        CONSTANT.COMPLIMENTARY_MODIFIER,
      ],
      items: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
    });

    if (item) {
      if (updatedOrder.modifiers.length === 0) {
        dispatch(addItem(item));
      }
    }

    itemBuckets.addCoreModifierMemoryChip(
      CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
      item?.bucket,
      item?.items_modifier_groups,
    );
    item && handleSyncIngredients(item);
    // Force remount of ItemOrder to clear its local state (e.g., madeForName, quantity)
    setItemOrderResetKey((prev) => prev + 1);
    window.scrollTo({
      top: 0,
      behavior: "smooth" // Smooth scrolling animation
    });
  };

  const scrollOnSize = () => {
    setTimeout(() => {
      const yOffset = -200;
      const ScrollYCordinates =
        autoScrollDivRef?.current?.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;
      !unavailableModifiersListData &&
        showCustomizedOptions &&
        window.scrollTo({ top: ScrollYCordinates, behavior: 'smooth' });
    }, 250);
  };

  const handleScrollToCustomisation = () => {
    setTimeout(() => {
      const yOffset = -350;
      if (autoScrollDivRef.current) {
        const ScrollYCordinates =
          autoScrollDivRef?.current?.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;
        window.scrollTo({ top: ScrollYCordinates, behavior: 'smooth' });
      }
    }, 500);
  };

  //Wrapper function to sync ingredients
  const handleSyncIngredients = async (item) => {
    const zeroPriceCore = [];
    if (
      isEdit &&
      (!editCartItem || (editCartItem && item?.id !== editCartItem.item_id))
    )
      return;
    let ingredients = _clonedeep(availableModifiers(item));
    if (ingredients.length) {
      ingredients = sortBasedOnPriceByModifierGroups(ingredients);
    }
    for (let i = 0; i < ingredients.length; i++) {
      let customizedIngredient = null;
      let quantity = parseInt(ingredients[i].quantity) || 1;
      let iterations = 1;
      let data: any = {
        modifier_id: ingredients[i].id,
        modifier_name: ingredients[i].name,
        modifier_group_id: ingredients[i].modifier_group_id,
        modifier_calories: ingredients[i].calories,
        brink_id: ingredients[i].brink_modifier_id,
        quantity: quantity,
        brink_modifier_group_id: ingredients[i].brink_modifier_group_id,
        display_price: ingredients[i].price,
        original_price: ingredients[i].original_price,
        core: true,
        type: CONSTANT.BY_DEFAULT,
        modifier_type: CONSTANT.CORE_MODIFIERS,
      };
      //In case of Edit update core modifier selection
      if (isEdit && editCartItem?.core_modifiers) {
        let customizedIngredients = _clonedeep(
          editCartItem.core_modifiers ?? []
        );
        if (customizedIngredients.length) {
          customizedIngredients = sortBasedOnPriceByModifierGroups(
            customizedIngredients
          );
        }
        customizedIngredient = customizedIngredients.find(
          (mod) => mod.modifier_id === ingredients[i].id
        );
        
        if (customizedIngredient) {
          customizedIngredient.price = ingredients[i].price;
        }
      }
      iterations =
        customizedIngredient?.quantity > 1 ? customizedIngredient?.quantity : 1;

      // save zero price core to add them at the end
      if (
        customizedIngredient?.price === 0 &&
        isEdit &&
        editCartItem?.core_modifiers
      ) {
        zeroPriceCore.push({
          customizedIngredient,
          data,
          iterations,
          quantity,
        });
        continue;
      }

      for (let j = 0; j < iterations; j++) {
        let tempQuantity = 0;
        if (customizedIngredient) data.code = customizedIngredient.code;
        if (data.code === CONSTANT.ADD) {
          tempQuantity = j + 1;
          data.type = j === 0 ? CONSTANT.BY_DEFAULT : CONSTANT.INCREASE;
          data.code = CONSTANT.ADD;
        } else if (data.code === CONSTANT.NO) {
          data.type = CONSTANT.DECREASE;
          tempQuantity = 0;
        } else {
          tempQuantity = quantity;
        }

        const { itemId, activeBucket, itemModifiers } = calculatePriceForItem({
          currentModifier: { ...data, quantity: tempQuantity },
          item_id: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
        });
        if (data.code === CONSTANT.NO) break;
      }
    }
    await handleDefaultModifiers();
    if (isEdit && editCartItem) {
      if (editCartItem.no_required_modifier)
        await noDressingHandler(editCartItem.no_required_modifier);
      await processEditItemModifiers(editCartItem, item);
      await handleZeroCode(zeroPriceCore);
    }

    await handleSync86Ingredients(item);
    updateRedux();
  };

  const handleZeroCode = async (
    zeroPriceCore: {
      customizedIngredient: any;
      data: any;
      iterations: number;
      quantity: number;
    }[]
  ) => {
    zeroPriceCore.forEach((element) => {
      const { customizedIngredient, data, iterations, quantity } = element;
      for (let j = 0; j < iterations; j++) {
        let tempQuantity = 0;
        if (customizedIngredient) data.code = customizedIngredient.code;
        if (data.code === CONSTANT.ADD) {
          tempQuantity = j + 1;
          data.type = j === 0 ? CONSTANT.BY_DEFAULT : CONSTANT.INCREASE;
          data.code = CONSTANT.ADD;
        } else if (data.code === CONSTANT.NO) {
          data.type = CONSTANT.DECREASE;
          tempQuantity = 0;
        } else {
          tempQuantity = quantity;
        }

        const { itemId, activeBucket, itemModifiers } = calculatePriceForItem({
          currentModifier: { ...data, quantity: tempQuantity },
          item_id: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
        });
        if (data.code === CONSTANT.NO) break;
      }
    });
  };

  const updateRedux = () => {
    const priceArray = [];
    const itemBucket = itemBuckets.getBuckets();
    itemBucket?.forEach((currentItemBucket) => {
      const bucketTypes = Object.keys(currentItemBucket?.bucket);
      bucketTypes.forEach((type) => {
        const activeBucket = currentItemBucket?.bucket[type];
        const itemId =
          currentItemBucket?.item === 2 ? CONSTANT.COMPLEMENTARY_ITEM : 1;
        priceArray.push({ activeBucket, itemId });
      });
    });
    const otherModifiers = modifiersAgainstAnItem({
      itemType: CONSTANT.SINGLE_ITEM,
      itemId: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
    });
    const complimentaryModifiers = modifiersAgainstAnItem({
      itemType: CONSTANT.COMPLEMENTARY_ITEM,
      itemId: CONSTANT.COMPLEMENTARY_SELECTED_SECTION_FOR_SINGLE_ITEM,
    });
    const updatedModifiers = [];

    updatedModifiers.push({ itemModifiers: otherModifiers, itemId: 1 });
    updatedModifiers.push({
      itemModifiers: complimentaryModifiers,
      itemId: CONSTANT.COMPLEMENTARY_ITEM,
    });

    dispatch(updateModifiers(updatedModifiers));
    dispatch(updatePriceForAllItem(priceArray));
  };
  const handleDefaultModifiers = async () => {
    const selectedModifiers = item.is_selected;
    const complimentaryModifiers = item.complementary_items ?? [];

    complimentaryModifiers.forEach((modifier) => {
      modifier.modifiers_groups_modifiers?.forEach((selectedItem) => {
        if (!selectedItem.is_selected) return;
        let payload = createPayloadToSync(
          { ...selectedItem, modifier_type: CONSTANT.COMPLIMENTARY_MODIFIER },
          item
        );
        calculatePriceForItem({
          currentModifier: payload,
          item_id: CONSTANT.COMPLEMENTARY_SELECTED_SECTION_FOR_SINGLE_ITEM,
        });
      });
    });

    selectedModifiers.forEach((selectedItem) => {
      let payload = createPayloadToSync(
        { ...selectedItem, modifier_type: CONSTANT.CORE_MODIFIERS },
        item
      );
      calculatePriceForItem({
        currentModifier: payload,
        item_id: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
      });
    });
    return true;
  };

  const handleSync86Ingredients = async (item) => {
    const ingredients = unavailableModifiers(item);
    for (let i = 0; i < ingredients.length; i++) {
      const data: any = {
        modifier_id: ingredients[i].id,
        modifier_name: ingredients[i].name,
        modifier_group_id: ingredients[i].modifier_group_id,
        modifier_group_min: ingredients[i].modifier_group_min,
        modifier_calories: ingredients[i].calories,
        brink_id: ingredients[i].brink_modifier_id,
        quantity: 0,
        brink_modifier_group_id: ingredients[i].brink_modifier_group_id,
        display_price: ingredients[i].price,
        type: CONSTANT.DECREASE,
        modifier_type: CONSTANT.CORE_MODIFIERS,
      };
      const { itemId, activeBucket, itemModifiers } = calculatePriceForItem({
        currentModifier: data,
        item_id: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
      });
    }
    return true;
  };

  const handelRedeemSize = () => {
    dispatch(
      sizeSelection({
        size: null,
        brink_id: item.full_brink_item_id,
        display_price: item.price,
      })
    );
    if (!redeemSize) {
      if (reward_size?.toUpperCase() === CONSTANT.HALF_SIZE.id)
        setRedeemSize({ size: CONSTANT.HALF_SIZE.id, selected: true });
      else if (reward_size?.toUpperCase() === CONSTANT.LARGE_SIZE.id)
        setRedeemSize({ size: CONSTANT.LARGE_SIZE.id, selected: true });
    } else {
      if (redeemSize.size == CONSTANT.HALF_SIZE.id) {
        setRedeemSize({ size: CONSTANT.LARGE_SIZE.id, selected: true });
      }
      if (redeemSize.size == CONSTANT.LARGE_SIZE.id) setRedeemSize(null);
    }
  };

  const isCreateYourOwnItem = isItCreateYourOwnItem(item?.is_create_your_own);

  const unrepeatedIngredients = item
    ? [
        ...item.core_modifiers,
        ...item.items_required_modifier_groups
          .map((group) => group.required_modifiers_groups_modifiers)
          .flat(),
      ]
    : [];

  // Wrapper function for add ingredients
  const handleIngredientSelection: (data: any, id?: 1 | 2 | 3 | 4) => void = (
    data,
    id = CONSTANT.SINGLE_ITEM_SELECTED_SECTION
  ) => {
    const { itemId, activeBucket, itemModifiers } = calculatePriceForItem({
      currentModifier: data,
      item_id: id,
    });
    dispatch(updateTry2ComboSelectedModifiers({ itemModifiers, itemId }));
    if (activeBucket !== undefined) {
      dispatch(updatePriceForItem({ itemId, activeBucket }));
    }
    trackProductPageModifierClick(data);
    if (data?.related_modifier_group) {
      const parent = resolveParentTrayItemForChips(
        item,
        id,
        order,
        undefined,
        undefined
      );
      if (data?.modifier_count != null) {
        const newMax = data?.modifier_count;
        trimSandwichTrayChipsSelections({
          itemsAsModifier,
          parentTrayItem: parent,
          newChipsMax: newMax,
          order,
          dispatch,
          setItemsAsModifier,
          relatedGroup: data?.related_modifier_group,
        });
      }
    }
    setForceRender(!forceRender);
  };

  const showModifierModal = () => {
    itemBuckets?.createBucketCopy();
    setShowCustomizedOptions(true);
    setModalShow(true);
  };
  const hideModifierModal = () => {
    setModalShow(false);
    if (firstTimeModal) {
      setFirstTimeModal(false);
    }
  };

  const addSelectedModifiers = (selectedModifier, commulativeItems): void => {
    selectedModifier?.modifiers.forEach((element) => {
      const index = commulativeItems.findIndex(
        (e) => e.groupId === element?.modifier_group_id
      );
      if (index !== -1) {
        commulativeItems[index].quantity =
          commulativeItems[index].quantity + element?.quantity;
        commulativeItems[index].noDressing = false;
      } else {
        const trackObj = {
          groupId: element?.modifier_group_id,
          quantity: element?.quantity,
          noDressing: false,
        };
        commulativeItems.push(trackObj);
      }
    });
  };

  const addNoDressings = (selectedModifier, commulativeItems): void => {
    selectedModifier?.noDressings.forEach((element) => {
      const index = commulativeItems.findIndex(
        (e) => e.groupId === element?.id
      );
      if (index === -1) {
        const trackObj = {
          groupId: element?.id,
          quantity: 0,
          noDressing: element?.noDressing,
        };
        commulativeItems.push(trackObj);
      } else {
        commulativeItems[index].noDressing = element?.noDressing;
      }
    });
  };

  const getOrderButtonState = (
    type
  ): { status: boolean; missingGroupIndex?: number } => {
    if (!availableForSelectedOrderType(item, orderType))
      return { status: true };
    const selectedModifier = itemBuckets.getSingleBucket({
      name: CONSTANT.REQUIRED_MODIFIERS,
      fromItem: CONSTANT.SINGLE_ITEM_SELECTED_SECTION,
    });
    const commulativeItems = [];
    let missingGroupIndex = null;

    if (
      (type && order?.size && item?.half_brink_item_id) ||
      (type && !order?.size && !item?.half_brink_item_id) ||
      (type && isEdit && order?.size && !item?.half_brink_item_id)
    ) {
      const subItemsSatisfied = () =>
        !item?.sub_items_required_modifier_groups?.length ||
        areStandaloneSubItemModifierSelectionsComplete({
          trayItem: item,
          order,
          itemsAsModifier,
          isCustomizeSectionExposed:
            showCustomizedOptions || showCustomizationOnEdit,
        });

      const hasRequiredGroups =
        (item?.items_required_modifier_groups?.length ?? 0) > 0;

      if (!hasRequiredGroups) {
        if (!subItemsSatisfied()) {
          return { status: true, missingGroupIndex };
        }
        return { status: false };
      }

      addSelectedModifiers(selectedModifier, commulativeItems);
      if (selectedModifier?.noDressings) {
        addNoDressings(selectedModifier, commulativeItems);
      }
      let isMinExeceeded = null;

      for (let i = 0; i < item?.items_required_modifier_groups.length; i++) {
        const itemIndex = commulativeItems.findIndex(
          (e) => e.groupId === item?.items_required_modifier_groups[i].id
        );
        missingGroupIndex = i;
        const minReached =
          commulativeItems[itemIndex]?.noDressing === false
            ? commulativeItems[itemIndex]?.quantity > 0 &&
              commulativeItems[itemIndex]?.quantity >=
                item?.items_required_modifier_groups[i].min
            : true;
        if (itemIndex === -1 || !minReached) {
          isMinExeceeded = false;
          break;
        } else {
          isMinExeceeded = true;
        }
      }

      if (isMinExeceeded && !subItemsSatisfied()) {
        return { status: true, missingGroupIndex };
      }

      const isSizeSelected = item?.half_brink_item_id
        ? order?.size.toLowerCase() === CONSTANT.HALF_SIZE.id.toLowerCase()
        : true;
      if (type === APPLY && isMinExeceeded) {
        return { status: false };
      } else if (type === CONSTANT.ADD_TO_ORDER && isMinExeceeded) {
        return { status: false };
      } else if (type === CONSTANT.CUSTOMIZE) {
        return { status: false };
      } else if (
        type === CONSTANT.MAKE_IT_A_TRY_2_COMBO &&
        isSizeSelected &&
        isMinExeceeded
      ) {
        return { status: false };
      } else {
        return {
          status: true,
          missingGroupIndex,
        };
      }
    } else {
      return {
        status: true,
        missingGroupIndex,
      };
    }
  };
  const availableForOrderType = () => {
    return (
      isOrderTypeSelected && availableForSelectedOrderType(item, savedOrderType)
    );
  };

  const noDressingHandler = (modifiers: any) => {
    for (let i = 0; i < modifiers.length; i++) {
      itemBuckets.resetChangesOnNoDreesing(1, { ...modifiers[i], quantity: 1 });
    }
  };
  const isItemAvailable = () => {
    return (
      item.is_active &&
      verifyStatus(item, 'item_location') &&
      availableForOrderType()
    );
  };

  const isItSandWichAndNotMultiSize = () => {
    if (
      item?.category_id?.toString() === CONSTANT.REACT_APP_SANDWICHES_ID &&
      !item?.half_brink_item_id
    ) {
      return true;
    } else {
      if (item?.half_brink_item_id) return true;
      else return false;
    }
  };
  const isCheckTrackBar = useTrackBarVisibility();

  const isDesignV2 = useIsDesignV2()
  // const [isFirstVisible, firstRef] = useVisibility<HTMLDivElement>(-100);

  return !item || isFetching || editItemFetching ? (
    <Spinner />
  ) : (
    <>
      <SelectMenuItemScript
        item={item}
        scriptType={"select_item"}
        location_id={locationInfo?.selectedStore?.id}
        userId={authInfo.userId}
      />
      <ItemScript
        item={item}
        scriptType={"view_item"}
        location_id={locationInfo?.selectedStore?.id}
        userId={authInfo.userId}
      />
      {order?.modifiers?.length > 0 && (
        <div className={styleClasses.order_content_wrapper}>
          {!isDesignV2 && (
            <ItemDetailMenuCategory category_id={category_id} />
          )}
          {isDesignV2 && (
            <div className={`text-start mt-2 mb-2 ms-2 ${styleClasses.category_back_button_mobile_designv2} ${
                  isCheckTrackBar
                    ? styleClasses.track_here_order_category_back_button_mobile_designv2
                    : styleClasses.no_track_order_category_back_button_mobile_designv2
                }`}>
              <Link
                to={item?.category_name ? CONSTANT.ROUTE_MENU+"/"+item.category_name  : CONSTANT.ROUTE_MENU}
                className="btn btn-custom back-arrow-btn f-s14 px-0 mb-0"
              >
                {item?.category_name ?? "Menu"}
              </Link>
            </div>
          )}
          <Container fluid>
            <div
              className={`${styleClasses.item_main_div} ${isDesignV2 ? styleClasses.item_main_div_mobile_designv2 : ''} d-flex flex-column h-100`}
            >
              <Row
                className={`align-items-start ${styleClasses.single_item_detail_wrapper} ${
                  isCheckTrackBar
                    ? styleClasses.track_here_order_detail_wrapper
                    : styleClasses.no_track_order_detail_wrapper
                }`}
              >
                <Col lg="7">
                  <div className={styleClasses.item_img_wrap}>
                    <img
                      src={`${CONSTANT.REACT_APP_CLOUD_FRONT}${item.image}?v=${item?.image_version || Date.now()}`}
                      className="img-fluid"
                      alt={item.name}
                    />
                  </div>
                </Col>
                <Col
                  lg="5"
                  md="11"
                  className={`${styleClasses.item_info_wrap} single-item-info-wrap`}
                >
                  <ItemOrder
                    key={itemOrderResetKey}
                    item={item}
                    styleClasses={styleClasses}
                    order={order}
                    handelRedeemSize={handelRedeemSize}
                    reward_size={reward_size}
                    handleIngredientSelection={handleIngredientSelection}
                    unrepeatedIngredients={unrepeatedIngredients}
                    forceRender={forceRender}
                    setForceRender={(forceRender) =>
                      setForceRender(forceRender)
                    }
                    handleSyncIngredients={handleSyncIngredients}
                    showCustomization={isEdit}
                    redeemSize={redeemSize}
                    setShowCustomizedOptions={(state) => {
                      setShowCustomizedOptions(true);
                    }}
                    firstTimeModal={firstTimeModal}
                    setFirstTimeModal={setFirstTimeModal}
                    scrollOnSize={scrollOnSize}
                    handleScrollToCustomisation={handleScrollToCustomisation}
                    addToOrder={handleAddToOrder}
                    showModifierModal={showModifierModal}
                    loading={loading}
                    showCustomizedOptions={showCustomizedOptions}
                    getOrderButtonState={getOrderButtonState}
                    addToOrderButtonShown={(state: boolean) =>
                      setAddToOrderStickyButton(state)
                    }
                    requiredModifiersAtItemDetailSectionToHandleScroll={
                      requiredModifiersAtItemDetailSectionToHandleScroll
                    }
                    CYOIScrollToMissingRequiredArea={
                      requiredCYOIModifiersToHandleScroll
                    }
                    editItemQuantity={editCartItem?.quantity}
                    recipient_name={editCartItem?.recipient_name}
                    itemDetailReady={!isFetching && !editItemFetching && Boolean(item)}
                    isItemRedeemed={isItemRedeemed}
                    isItemAvailable={isItemAvailable}
                    isItSandWichAndNotMultiSize={isItSandWichAndNotMultiSize}
                    showMakeItTryToCombo={showMakeItTryToCombo(
                      item?.category_name
                    )}
                    dbId={dbId}
                    isNavigatingToCombo={isNavigatingToCombo}
                    location_id={location_id}
                  />
                </Col>
              </Row>
            </div>
          </Container>
          {/* Customized screen  */}
          <Customization
            item={item}
            unrepeatedIngredients={unrepeatedIngredients}
            showCustomizedOptions={showCustomizedOptions}
            showCustomization={showCustomizationOnEdit}
            handleIngredientSelection={handleIngredientSelection}
            modalShow={modalShow}
            handleSyncIngredients={handleSyncIngredients}
            hideModifierModal={hideModifierModal}
            autoScrollDivRef={autoScrollDivRef}
            firstTimeModal={firstTimeModal}
            CYOIScrollToMissingRequiredArea={
              requiredCYOIModifiersToHandleScroll
            }
            itemAsModifierState={{
              itemsAsModifier,
              setItemsAsModifier,
            }}
            // firstRef={firstRef}
          />
        </div>
      )}

      {authInfo.type !== CONSTANT.GUEST_USER && !isDesignV2 ? (
        <UserSelections
          isBtnStyles={true}
          isMakeitBtnShowing={
            showMakeItTryToCombo(item?.category_name) &&
            !isEdit &&
            isItemAvailable() &&
            isItSandWichAndNotMultiSize() &&
            !isCreateYourOwnItem &&
            isThisMobile &&
            (order?.size == CONSTANT.HALF_SIZE.upper_case ||
              !item.half_brink_item_id)
          }
        />
      ) : (
        ''
      )}
      {showModal && (
        <AddedModal
          item={customizedItem}
          categoryName={item?.category_name ?? "Menu"}
          showModal={showModal}
          closeModal={closeAddedModal}
          closeModalAndOpenCart={() => {
            resetItem();
            setshowModal(false);
            dispatch(setShowCart(true))
          }}
          name={getItemDetailForAddToOrderModal('name', order, item)}
          image={getItemDetailForAddToOrderModal('image', order, item)}
          isCombo={false}
          setshowModal={setshowModal}
        />
      )}
    </>
  );
};

const useScrollToMissingRequiredArea = (item) => {
  const [
    requiredModifiersRefsForScrollToMissingSelectedGroupInItemDetailSection,
    setRequiredModifiersRefsForScrollToMissingSelectedGroupInItemDetailSection,
  ] = useState([]);

  const [
    requiredModifiersRefsForScrollToMissingSelectedGroupInCYOI,
    setRequiredModifiersRefsForScrollToMissingSelectedGroupInCYOI,
  ] = useState([]);

  const [
    isRequiredModifiersAtItemDetailSectionSelected,
    setIsRequiredModifiersAtItemDetailSectionSelected,
  ] = useState({
    status: false,
    highLightArea: null,
  });

  const [isCYOIRequiredModifierSelected, setIsCYOIRequiredModifierSelected] =
    useState({ status: false, highLightArea: null });

  useEffect(() => {
    const reqLen = item?.items_required_modifier_groups?.length ?? 0;
    if (item) {
      assignRefForScroll({
        requiredSectionLength: reqLen,
        refState: requiredModifiersRefsForScrollToMissingSelectedGroupInCYOI,
        setRefState:
          setRequiredModifiersRefsForScrollToMissingSelectedGroupInCYOI,
      });
    }
    if (item && reqLen > 0) {
      assignRefForScroll({
        requiredSectionLength: reqLen,
        refState:
          requiredModifiersRefsForScrollToMissingSelectedGroupInItemDetailSection,
        setRefState:
          setRequiredModifiersRefsForScrollToMissingSelectedGroupInItemDetailSection,
      });
    }
  }, [item]);

  function assignRefForScroll({
    requiredSectionLength,
    refState,
    setRefState,
  }) {
    const divRefsNew = refState;
    divRefsNew.length = requiredSectionLength;
    // Initialize the refs
    for (let i = 0; i < divRefsNew.length; i++) {
      divRefsNew[i] = divRefsNew[i] || React.createRef();
    }
    setRefState(divRefsNew);
  }

  return {
    requiredModifiersAtItemDetailSectionToHandleScroll: {
      refToScrollToMissingRequiredModifiers:
        requiredModifiersRefsForScrollToMissingSelectedGroupInItemDetailSection,
      isRequiredModifierSelected:
        isRequiredModifiersAtItemDetailSectionSelected,
      setIsRequiredModifierSelected:
        setIsRequiredModifiersAtItemDetailSectionSelected,
    },
    requiredCYOIModifiersToHandleScroll: {
      refToScrollToMissingRequiredArea:
        requiredModifiersRefsForScrollToMissingSelectedGroupInCYOI,
      isCYOIRequiredModifierSelected,
      setIsCYOIRequiredModifierSelected,
    },
  };
};

const getItemDetailForAddToOrderModal = (get:'name' | 'image', order, item): string => {
  const reqGroups = item?.items_required_modifier_groups ?? [];
  const singleSelectedItem =
    reqGroups.length === 1 &&
    (item?.items_modifier_groups?.length ?? 0) === 0 &&
    (item?.core_modifiers?.length ?? 0) === 0 &&
    reqGroups[0].extendable_limit === 1 &&
    reqGroups[0].max === 1 &&
    reqGroups[0].min === 1;
  switch (get) {
    case 'name':
      if(!singleSelectedItem) return item?.name;
      const nameForNestedSelectedItem = order?.modifiers.find(
        (modifier) =>
          modifier.item == CONSTANT.SINGLE_ITEM_SELECTED_SECTION
      ).modifiers?.[0].modifier_name;
       if(nameForNestedSelectedItem) return nameForNestedSelectedItem;
      else return item?.name
      break;
      case 'image':
        if(!singleSelectedItem) return `${CONSTANT.REACT_APP_CLOUD_FRONT}${item?.image}`;
        const imageForNestedSelectedItem = order?.modifiers.find(
          (modifier) =>
            modifier.item == CONSTANT.SINGLE_ITEM_SELECTED_SECTION
        ).modifiers?.[0].image;
         if(imageForNestedSelectedItem) return imageForNestedSelectedItem;
        else return `${CONSTANT.REACT_APP_CLOUD_FRONT}${item?.image}`
        break;
    default:
      return ''
      break;
  }
}

export default Order;
